import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { formFieldPresence } from './variants';

export const MotionBox = motion(Box);

export const FormFieldPresence = ({ children }: { children: ReactNode }) => (
  <MotionBox
    variants={formFieldPresence}
    initial="hidden"
    animate="visible"
    exit="exit"
  >
    {children}
  </MotionBox>
);
